import { render, staticRenderFns } from "./LanguageSelector.vue?vue&type=template&id=0eb6efda&scoped=true"
import script from "./LanguageSelector.vue?vue&type=script&lang=ts"
export * from "./LanguageSelector.vue?vue&type=script&lang=ts"
import style0 from "./LanguageSelector.vue?vue&type=style&index=0&id=0eb6efda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb6efda",
  null
  
)

export default component.exports